import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { AsyncThunk } from "@reduxjs/toolkit";

import { useAppDispatch } from "../../store";
import { IModal } from "../../types/modal";
import { ConfirmationModal } from "../ConfirmModal";
import { showCustomToast } from "../CustomToast";

type ConfirmThunkModalProps<TPayload> = IModal & {
  isPaid: boolean;
  thunk: AsyncThunk<any, TPayload, any>;
  payload: TPayload;
  translationKey: string;
  isUpdating?: (state: any) => boolean;
};

export const ConfirmThunkModal = <TPayload,>({
  isPaid,
  thunk,
  payload,
  translationKey,
  isModalVisible,
  toggleModalVisibility,
  isUpdating,
}: ConfirmThunkModalProps<TPayload>) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const isConfirming = useSelector(isUpdating ?? (() => false));

  const handleConfirm = async () => {
    const result = await dispatch(thunk(payload));

    if (thunk.fulfilled.match(result)) {
      showCustomToast(t(`${translationKey}.successToast`), { type: "success" });
    } else {
      showCustomToast(t(`${translationKey}.errorToast`), { type: "error" });
    }
  };

  const textSuffix = isPaid ? "Unpaid" : "Paid";

  return (
    <ConfirmationModal
      isModalVisible={isModalVisible}
      toggleModalVisibility={toggleModalVisibility}
      title={t(`${translationKey}.title`)}
      text={t(`${translationKey}.text${textSuffix}`)}
      confirmText={t(`${translationKey}.buttonConfirm${textSuffix}`)}
      cancelText={t(`${translationKey}.buttonDecline`)}
      isConfirming={isConfirming}
      onSuccess={handleConfirm}
    />
  );
};
